import * as React from "react";
import styled from "styled-components";
import { MenuItem } from "components/bootstrap";
import ActionMenuItem from "views/components/actions/ActionMenuItem";
import { Spinner } from "components/common";
import useExternalValueActions from "views/hooks/useExternalValueActions";
import useFieldActions from "views/components/actions/useFieldActions";
const DropdownHeader = styled.span`
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 5px;
  margin-bottom: 5px;
  font-weight: 600;
`;
const StyledListItem = styled.li`
  margin-bottom: 10px;
  list-style: none;
`;
const filterVisibleActions = (evaluateCondition, handlerArgs, actions = []) => actions.filter((action) => {
  const { isHidden = () => false } = action;
  const hidden = evaluateCondition(isHidden, handlerArgs, false);
  return !hidden;
});
const useInternalActions = (type, handlerArgs) => {
  const { evaluateCondition, valueActions, fieldActions } = useFieldActions();
  const actions = type === "value" ? valueActions : fieldActions;
  if (type === "value") {
    return filterVisibleActions(evaluateCondition, handlerArgs, actions);
  }
  if (type === "field") {
    return filterVisibleActions(evaluateCondition, handlerArgs, actions);
  }
  return [];
};
const useExternalActions = (type, handlerArgs) => {
  const { isLoading, isError, externalValueActions } = useExternalValueActions();
  const { evaluateCondition } = useFieldActions();
  if (type !== "value") {
    return { isLoading, isError, externalActions: [] };
  }
  const externalActions = filterVisibleActions(evaluateCondition, handlerArgs, externalValueActions);
  return { isLoading, isError, externalActions };
};
const ActionDropdown = ({
  children = null,
  type,
  handlerArgs,
  setOverflowingComponents,
  overflowingComponents,
  onMenuToggle
}) => {
  const internalActions = useInternalActions(type, handlerArgs);
  const { externalActions, isLoading } = useExternalActions(type, handlerArgs);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledListItem, null, /* @__PURE__ */ React.createElement(DropdownHeader, null, children)), /* @__PURE__ */ React.createElement(MenuItem, { divider: true })), /* @__PURE__ */ React.createElement(MenuItem, { header: true }, "Actions"), internalActions.map((action) => /* @__PURE__ */ React.createElement(
    ActionMenuItem,
    {
      action,
      key: `${type}-action-${action.type}`,
      handlerArgs,
      setOverflowingComponents,
      overflowingComponents,
      type,
      onMenuToggle
    }
  )), isLoading && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(MenuItem, { disabled: true }, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading" }))), !isLoading && externalActions && externalActions.length !== 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), externalActions.map((action) => /* @__PURE__ */ React.createElement(
    ActionMenuItem,
    {
      action,
      key: `${type}-action-${action.type}`,
      handlerArgs,
      setOverflowingComponents,
      overflowingComponents,
      type,
      onMenuToggle
    }
  ))));
};
export default ActionDropdown;
